var n = /* @__PURE__ */ ((_) => (_.Anima = "Item_ronin_erc20_0101", _.Animus = "Item_token_0301", _.Aprm = "Item_token_0302", _.Aprs = "Item_ronin_erc20_0102", _.AprsRon = "Item_ronin_erc20_0106", _.AnimaRon = "Item_ronin_erc20_0108", _.Stardust = "Item_token_0203", _.Usdc = "Item_ronin_erc20_0104", _.Weth = "Item_ronin_erc20_0103", _.WRon = "Item_ronin_erc20_0107", _.DoodWings = "Item_token_0303", _.DoodHalo = "Item_token_0304", _.Unspecify = "", _))(n || {});
export {
  n as AssetName
};
//# sourceMappingURL=asset.js.map
